import { setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeTargetType } from "../Data/WBData";
import ColorInputField from "./ColorInputField";
import { AttributeFieldProps } from "./RenderAttributeInput";

export default function StarColor({definition,layoutObject,updateFunc,saveFunc,screenSize,siteData,label}:AttributeFieldProps){

        //const val = GetComponentOrStyleValueFromDefinition(definition,siteData.siteStyling.misc,screenSize);

        const onUpdate = (attribute:string,value:string,targetType:AttributeTargetType)=>{
            setNodeComponentAttributeValue(siteData.siteStyling.misc,attribute,value);
            siteData.onUpdateStyle&&siteData.onUpdateStyle();
            siteData.isStylePublishDirty = true;
            siteData.isStyleSaveDirty = true;
         
            //saveFunc();

        }

        return( 
        <ColorInputField definition={definition} layoutObject={siteData.siteStyling.misc} updateFunc={onUpdate} saveFunc={saveFunc} screenSize={screenSize} siteData={siteData} label={label} />
    );
}